import Nav from './Nav';
import Footer from './Footer';
import { Link } from 'react-router-dom';

export default function NotFound() {
  document.title = "404 Page Not Found | Arisu";

  return (
    <>
      <Nav />
      <div className="mx-4 md:mx-8 my-16">
        <h3 className="text-2xl mb-2">It looks like you're lost, little bunny!</h3>
        <button className="underline text-xl">
            <Link to="/">
              Take me to the homepage!
            </Link>
        </button>
      </div>
      <Footer />
    </>
  )
}